import React, { useState, useEffect } from "react";
import { Autocomplete } from "@mantine/core";
import axios from "axios";

import { useDebounce } from "../../../hooks/useDebounce";
import { GEOAPIFY_API_KEY, getLocationFormat } from "../../../../utils/Filters";

export default function SurveyLocationInput({ label, size, value, options, onChange }) {
  const [searchData, setSearchData] = useState([]);
  const [search, setSearch] = useState(typeof value === "string" ? value : "");
  const [updated, setUpdated] = useState(false);

  const locationFormat = options?.format || "city_country";
  
  useEffect(() => {
    if (typeof value?.place_id === "string" && !updated) {
      const locationValue = getLocationFormat(value, locationFormat);
      setSearch(locationValue);
      setUpdated(true);
    }
  }, [value, updated]);

  const handleUpdate = (val) => {
    if (typeof onChange === "function") {
      onChange(val);
    }
  };

  const onSearch = (val) => {
    if (val.length > 0) {
      axios.get(`https://api.geoapify.com/v1/geocode/autocomplete`, { 
        params: {
          text: val,
          format: "json",
          type: locationFormat === "city_country" ? "city" : locationFormat === "country" ? "country" : undefined,
          lang: "en",
          apiKey: GEOAPIFY_API_KEY
        }
      })
      .then((res) => {
        if (Array.isArray(res?.data?.results)) {
          setSearchData(res.data.results);
        }
      })
      .catch((error) => console.log("GEOAPIFY_ERROR:", error?.message, error?.response, error));
    } else {
      if (searchData.length > 0) setSearchData([]);
    }
  };

  const debouncedSearch = useDebounce((val) => onSearch(val), 500);

  const data = searchData.map((item) => {
    const newValue = getLocationFormat(item, locationFormat);
    return { value: newValue || `${item.city}, ${item.country}`, place_id: item.place_id };
  });

  const seen = new Set();
  const dataFiltered = data.filter((item) => {
    if (seen.has(item.value)) return false;
    seen.add(item.value);
    return true;
  });

  return (
    <Autocomplete
      value={search}
      size={size}
      label={label}
      placeholder="Search for location"
      data={dataFiltered}
      zIndex={999999}
      onChange={(value) => {
        setSearch(value);
        debouncedSearch(value);
      }}
      onItemSubmit={(item) => {
        const locationItem = searchData.find((l) => l.place_id === item.place_id);
        if (locationItem) {
          handleUpdate(locationItem);
        }
      }}
      filter={(val, item) => {
        if (!val || typeof item.value !== "string") return true;
        return item.value.toLowerCase().includes(val.toLowerCase()) || item.value !== val;
      }}
    />
  );
}